export const COMPARISON_MODES = {
  SWLY: 'SWLY',
  SDLY: 'SDLY',
  PP: 'PP',
  CUSTOM: 'custom',
} as const;

export type ComparisonMode =
  (typeof COMPARISON_MODES)[keyof typeof COMPARISON_MODES];

export const STAY_DATE_GRANULARITIES = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
} as const;

export type StayDateGranularity =
  (typeof STAY_DATE_GRANULARITIES)[keyof typeof STAY_DATE_GRANULARITIES];

export const DATE_FORMAT = 'YYYY-MM-DD';
